import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { Data } from '../../data/Data';
import { DataDocument } from '../../data/DataDocument';
import { DataOperation } from '../../data/DataOperation';
import miniatureManquante from '../../images/miniatureManquante.png';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { SpinnerChargement } from '../Loader/SpinnerChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheOperation.css';

/****************************************************************
 PROPS:
    idOperation
    idLot
    onAffichePanelOperation
    onFermeFicheOperation : méthode
    classnameinner : classe CSS (string)
    className : classe CSS (string)
****************************************************************/

var objetState = {
    idOperation: 0,
    idLot: 0,
    operation: {},
    objMail: {
        destinataire: "",
        copie: "",
        objet: "",
        listPiecesJointes: [],
        corps: ""
    },
    numLot: null,
    photos: [],
    documentsOperation: [],
    groupesDocumentsOperation: [],
    documentsLots: [],
    groupesDocumentsLots: [],
    detailsSelectionDocumentsOperation: null,
    detailsSelectionDocumentsLot: null,
    photoSelectionnee: null,
    affichageOperation: false,
    affichagePhotos: false,
    affichageDocuments: true,
    enCoursDeTraitement: false,
    photoEnCoursDeChargement: false,
    documentEnCoursDeChargement: false,
    envoiMailEnCours: false,
    envoiMailEffectue: false,
    messageEnCoursTraitement: '',
    messagePhotoEnCoursTraitement: '',
    messageDocumentEnCoursTraitement: '',
    messageEnvoiMailEnCours: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

const POIDS_TOTAL_MAX_PJS = 20;

export class FicheOperation extends Component {

    _creationSectionOperation() {
        return (
            <div className="containerOperation">
                <div className="ms-Grid-row zoneDetailOperation divTitreOperation">
                    <div className="ms-Grid-col ms-sm12">
                        <div className="nomOperation">{this.state.operation.nomCommercial} ({this.state.operation.cp})</div>
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <div className="adresseOperation">{this.state.operation.adresse} - {this.state.operation.ville}</div>
                    </div>
                </div>
                <div className="ms-Grid-row zoneDetailOperation">
                    <div className="ms-Grid-col ms-sm12 encartResponsableEI">
                        <div className="ms-Grid-col ms-sm12">
                            <div className="nomResponsableEI">Responsable EI : {this.state.operation.nom} {this.state.operation.prenom} ({this.state.operation.loginCompte})</div>
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Email : {this.state.operation.email}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Téléphone : {this.state.operation.tel}
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row zoneDetailOperation">
                    <div className="ms-Grid-col ms-sm12 ms-md6 zoneDetailDates">
                        <div className="ms-Grid-col ms-sm12">
                            Date commercialisation : {Scriba.date().stringDateFormatCourt(this.state.operation.dateLancementCommercialisation)}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Date début travaux : {Scriba.date().stringDateFormatCourt(this.state.operation.dateSignatureOSTravaux)}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <div className="dateLivraison">Date livraison : {Scriba.date().stringDateFormatCourt(this.state.operation.dateLivraison)}</div>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6">
                        <div className="ms-Grid-col ms-sm12">
                            Perf. énergétique : {this.state.operation.performanceEnergetique}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Certification : {this.state.operation.certification}
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            Zone fiscale : {this.state.operation.zoneFiscale}
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row zoneDetailOperation">
                    <div className="ms-Grid-col ms-sm12 ms-md6">
                        <div className="encartOperation">
                            <div>Descriptif commercial</div> {this.state.operation.descriptifCommercial}
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6">
                        <div className="encartOperation">
                            <div>Flash commercial</div> {this.state.operation.flashCommercial}
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row zoneDetailOperation">
                    <div className="ms-Grid-col ms-sm12 ms-md6">
                        <div className="encartForcesFaiblesses">
                            <div>Forces</div> {this.state.operation.forces}
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6">
                        <div className="encartForcesFaiblesses">
                            <div>Faiblesses</div> {this.state.operation.faiblesses}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _creationSectionPhotos() {
        let content = [];
        let _this = this;

        if (this.state.photos.length > 0) {
            this.state.photos.forEach(function (value, index) {
                content.push(<img key={value.rowGUID} alt={value.nom} src={(value.fileDataMiniature !== null ? `data:image/png;base64,${value.fileDataMiniature}` : miniatureManquante)} className="photoOperationMiniature" onClick={() => _this._affichagePhoto(value.rowGUID)} />);
            })
        }

        return (<div className="containerOperation">
            {this.state.photos.length > 0 ?
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg2 divPhotosMiniatures">{content}</div>
                        {this.state.photoEnCoursDeChargement ?
                            <SpinnerChargement label={this.state.messagePhotoEnCoursTraitement} />
                            :
                            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg10"><img alt="Taille réelle" src={(this.state.photoSelectionnee !== null ? `data:image/png;base64,${this.state.photoSelectionnee}` : miniatureManquante)} className="photoOperationTailleReelle" /></div>
                        }
                    </div>
                </div>
                : <div>Aucune photo</div>
            }
        </div>);
    }

    _creationSectionDocuments() {
        let contentPiecesJointes = [];
        let listePiecesJointes = this.state.objMail.listPiecesJointes;

        if (listePiecesJointes !== undefined && listePiecesJointes != null) {
            if (listePiecesJointes.length > 0) {
                listePiecesJointes.forEach(function (value, index) {
                    contentPiecesJointes.push(<div key={`pjOperation_${index}`} title={value.nom}><Icon iconName={Immocom.getIconeEnFonctionDeLExtension(value.nom)} /><div className="nomPieceJointeOperation">{value.nom}</div></div>)
                });
            }
        }

        const poidsTotalDesPiecesJointes = this._getPoidsTotalDesPJSelectionnees();

        return (<div className="containerOperation">
            <CommandBar
                items={this._getItems()}
                overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
            />
            <div className="ms-Grid containerOperation" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-xl4">
                        <div className="sousTitreDocumentsOperation">Documents opération</div>
                        <div>{this.state.detailsSelectionDocumentsOperation}</div>
                        <div className="scrollablePaneWrapper">
                            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                <DetailsList
                                    items={this.state.documentsOperation}
                                    groups={this.state.groupesDocumentsOperation}
                                    columns={[
                                        {
                                            key: 'logo', name: '', fieldName: 'logo', minWidth: 25, maxWidth: 25, isResizable: false, isIconOnly: true,
                                            onRender: (item) => {
                                                return <Icon iconName={Immocom.getIconeEnFonctionDeLExtension(item.nom)} className="iconeDocumentOperation" title="Télécharger" onClick={() => this._telechargementDocument(item.rowGUID)} />;
                                            }
                                        },
                                        {
                                            className: 'ms-hiddenXlDown',
                                            fieldName: 'poidsDocument',
                                            headerClassName: 'ms-hiddenXlDown',
                                            key: 'poidsDocument',
                                            minWidth: 50,
                                            maxWidth: 50,
                                            name: 'Poids',
                                            onRender: (item) => {
                                                const convertedFileSize = this._convertirKioEnMio(item.fileSize);
                                                return <span>{`${convertedFileSize === 0 ? "< 0.1" : convertedFileSize} Mo`}</span>;
                                            }
                                        },
                                        {
                                            key: 'nomDocument', name: 'Document', fieldName: 'nomDocument', minWidth: 100, maxWidth: 200,
                                            onRender: (item) => {
                                                const nomDocument = item.nom;
                                                return <span title={nomDocument}>{nomDocument}</span>;
                                            }
                                        }
                                    ]}
                                    groupProps={{
                                        showEmptyGroups: true
                                    }}
                                    selection={this._selectionDocumentsOperation}
                                />
                            </ScrollablePane>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-xl4">
                        <div className="sousTitreDocumentsOperation">Documents lot {this.state.numLot}</div>
                        <div>{this.state.detailsSelectionDocumentsLot}</div>
                        <div className="scrollablePaneWrapper">
                            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                <DetailsList
                                    items={this.state.documentsLots}
                                    groups={this.state.groupesDocumentsLots}
                                    columns={[
                                        {
                                            key: 'logo', name: '', fieldName: 'logo', minWidth: 25, maxWidth: 25, isResizable: false, isIconOnly: true,
                                            onRender: (item) => {
                                                return <Icon iconName={Immocom.getIconeEnFonctionDeLExtension(item.nom)} className="iconeDocumentOperation" title="Télécharger" onClick={() => this._telechargementDocument(item.rowGUID)} />;
                                            }
                                        },
                                        {
                                            className: 'ms-hiddenXlDown',
                                            fieldName: 'poidsDocument',
                                            headerClassName: 'ms-hiddenXlDown',
                                            key: 'poidsDocument',
                                            minWidth: 50,
                                            maxWidth: 50,
                                            name: 'Poids',
                                            onRender: (item) => {
                                                const convertedFileSize = this._convertirKioEnMio(item.fileSize);
                                                return <span>{`${convertedFileSize === 0 ? "< 0.1" : convertedFileSize} Mo`}</span>;
                                            }
                                        },
                                        {
                                            key: 'nomDocument', name: 'Document', fieldName: 'nomDocument', minWidth: 100, maxWidth: 200,
                                            onRender: (item) => {
                                                const nomDocument = item.nom;
                                                return <span title={nomDocument}>{nomDocument}</span>;
                                            }
                                        }
                                    ]}
                                    groupProps={{
                                        showEmptyGroups: true
                                    }}
                                    selection={this._selectionDocumentsLot}
                                />
                            </ScrollablePane>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl4">
                        <div className="sousTitreDocumentsOperation">Envoyer par email</div>
                        <div className="ms-Grid" dir="ltr">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        label="À"
                                        onChange={(event, newValue) => this._onChange(newValue, 'destinataire')}
                                        required
                                        value={this.state.objMail.destinataire}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        label="Cc"
                                        onChange={(event, newValue) => this._onChange(newValue, 'copie')}
                                        value={this.state.objMail.copie}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        label="Objet"
                                        onChange={(event, newValue) => this._onChange(newValue, 'objet')}
                                        value={this.state.objMail.objet}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12">
                                    <div>Pièces jointes (total : <b>{this._getPoidsTotalDesPJSelectionnees()} Mo</b>) :</div>
                                    <div className="listePiecesJointesEmailOperation">
                                        {contentPiecesJointes}
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        label="Corps"
                                        multiline
                                        onChange={(event, newValue) => this._onChange(newValue, 'corps')}
                                        rows={5}
                                        value={this.state.objMail.corps}
                                    />
                                </div>
                                {poidsTotalDesPiecesJointes >= 10 &&
                                    <div className="ms-Grid-col ms-sm12">
                                        <MessageBar
                                            messageBarType={poidsTotalDesPiecesJointes < POIDS_TOTAL_MAX_PJS ? MessageBarType.warning : MessageBarType.severeWarning}
                                            className="mt-2"
                                        >
                                            {poidsTotalDesPiecesJointes < POIDS_TOTAL_MAX_PJS ?
                                                "Attention : certains services de messageries n'autorisent pas la réception de mail dont le poids total des pièces jointes excède 10 Mo." :
                                                `Le poids total des pièces jointes ne peut excéder ${POIDS_TOTAL_MAX_PJS} Mo.`
                                            }
                                        </MessageBar>
                                    </div>
                                }
                                <div className="ms-Grid-col ms-sm12">
                                    <div className="d-flex align-items-center mt-2">
                                        {this.state.envoiMailEnCours ?
                                            <SpinnerChargement label={this.state.messageEnvoiMailEnCours} /> :
                                            <PrimaryButton
                                                disabled={!this._validationFormulaire(this.state.objMail)}
                                                onClick={this._envoyerMail}
                                                text="Envoyer"
                                            />
                                        }
                                        {this.state.envoiMailEffectue && <span className="alert alert-success p-1 m-0 ml-1">Envoi effectué avec succès</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }

    _creationContent() {
        let sectionAfficher = null;

        if (this.state.affichageOperation)
            sectionAfficher = this._creationSectionOperation();
        else if (this.state.affichagePhotos)
            sectionAfficher = this._creationSectionPhotos();
        else if (this.state.affichageDocuments)
            sectionAfficher = this._creationSectionDocuments();

        return (
            <Panel
                isOpen={this.props.onAffichePanelOperation}
                type={PanelType.extraLarge}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                headerText={`Détail de l'opération "${this.state.operation.ville} - ${this.state.operation.nomCommercial}"`}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.className}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <Pivot linkSize={PivotLinkSize.large} onLinkClick={this._onPivotLinkClick}>
                                <PivotItem headerText="DOCUMENTS" key="documents"></PivotItem>
                                <PivotItem headerText="PHOTOS" key="photos"></PivotItem>
                                <PivotItem headerText="OPERATION" key="operation"></PivotItem>
                            </Pivot>

                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {sectionAfficher}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        // Concaténation tableaux nullables : https://stackoverflow.com/questions/51992304/js-null-safe-array-concat/51992342
        this._selectionDocumentsOperation = new Selection({
            onSelectionChanged: () => {
                Scriba.state().setObjetPropriete(this, 'objMail', 'listPiecesJointes', [...this._selectionDocumentsOperation.getSelection() || [], ...this._selectionDocumentsLot.getSelection() || []]);
            }
        });

        this._selectionDocumentsLot = new Selection({
            onSelectionChanged: () => {
                Scriba.state().setObjetPropriete(this, 'objMail', 'listPiecesJointes', [...this._selectionDocumentsOperation.getSelection() || [], ...this._selectionDocumentsLot.getSelection() || []]);
            }
        });

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheOperation();
    }

    _onChange = (value, champ) => {
        Scriba.state().setObjetPropriete(this, 'objMail', champ, value);
    }

    _getItems = () => {
        return [
            {
                key: 'deletePieceJointe',
                name: 'Supprimer les pièces jointes',
                iconProps: {
                    iconName: 'Delete'
                },
                disabled: (this.state.objMail.listPiecesJointes !== undefined && this.state.objMail.listPiecesJointes.length > 0 ? false : true),
                onClick: () => this._reinitSelection()
            }
        ];
    }

    _convertirKioEnMio = (size) => {
        return Math.ceil((size / (1024 * 1024)) * 10) / 10;

    };

    _getPoidsTotalDesPJSelectionnees = () => {
        let poidsTotal = 0;
        let listPiecesJointes = this.state.objMail.listPiecesJointes;
        if (listPiecesJointes && listPiecesJointes.length > 0) {
            listPiecesJointes.forEach((pj) => {
                poidsTotal += pj.fileSize;
            });
        }
        poidsTotal = this._convertirKioEnMio(poidsTotal);
        return poidsTotal;
    };

    _reinitSelection = () => {
        this._selectionDocumentsOperation.setAllSelected(false);
        this._selectionDocumentsLot.setAllSelected(false);
        Scriba.state().setObjetPropriete(this, 'objMail', 'listPiecesJointes', []);
    }

    _envoyerMail = () => {
        let mail = this.state.objMail;

        if (this._validationFormulaire(mail)) {
            this.setState({ envoiMailEnCours: true, envoiMailEffectue: false, messageEnvoiMailEnCours: "Envoi du mail" });

            let onEnvoiEmailDocumentsOperation = Data._onEnvoiEmailDocumentsOperation(mail);

            onEnvoiEmailDocumentsOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    let stateTemp = {};
                    stateTemp.envoiMailEnCours = false;
                    stateTemp.envoiMailEffectue = true;
                    stateTemp.messageEnvoiMailEnCours = '';
                    stateTemp.affichageOperation = false;
                    stateTemp.affichagePhotos = false;
                    stateTemp.affichageDocuments = true;

                    if (retourVerif === null) {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                    }
                });
        }
    }

    _telechargementDocument(rowGUID) {
        var telechargementDocument = DataDocument._onTelechargementDocument(rowGUID);

        telechargementDocument
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                    return Scriba.fichier().EnregisterSous(document, objetData.nom);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            if (Scriba.formulaire().nEstPasVide(item.destinataire)) {
                let estEmailValide = (Scriba.officeUI().textField().texte().controleEmail(item.destinataire) === '');

                if (!estEmailValide) {
                    estValide = false;
                }
            }
            else {
                estValide = false;
            }
        }
        else {
            estValide = false;
        }

        estValide = estValide && this._getPoidsTotalDesPJSelectionnees() < POIDS_TOTAL_MAX_PJS;

        return estValide;
    }

    _chargementDonnees() {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        let idLotRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idLot, [0, this.state.idLot]);

        if (idOperationRenseigneeEtDifferent && idLotRenseigneeEtDifferent) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement de l'opération"
            });

            let chargementFicheOperation = DataOperation._chargementFicheOperation(this.props.idOperation);

            chargementFicheOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet[0];
                        let itemOperation = objetData;

                        let stateTemp = {};
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.idLot = this.props.idLot;
                        stateTemp.operation = itemOperation;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                        //Chargement des documents par défaut
                        this._getUtilisateurConnecte();
                        this._chargementDocumentsOperation();
                        this._chargementDocumentsLot();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            let stateTemp = {};
            stateTemp.idOperation = 0;
            stateTemp.idLot = 0;
            stateTemp.operation = {};
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _chargementPhotos() {
        let idOperation = this.props.idOperation;

        if (idOperation > 0) {
            this.setState({ photoEnCoursDeChargement: true, messagePhotoEnCoursTraitement: "Chargement des photos de l'opération" });

            let rowGUIDPremierePhoto = null;

            let chargementFicheOperation_Photos = DataOperation._chargementFicheOperation_Photos(idOperation);

            chargementFicheOperation_Photos
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        rowGUIDPremierePhoto = (objetData.length > 0 ? objetData[0].rowGUID : null);

                        let stateTemp = {};
                        stateTemp.affichageOperation = false;
                        stateTemp.affichagePhotos = true;
                        stateTemp.affichageDocuments = false
                        stateTemp.photos = objetData;
                        stateTemp.photoEnCoursDeChargement = false;
                        stateTemp.messagePhotoEnCoursTraitement = '';
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                        this._affichagePhoto(rowGUIDPremierePhoto);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            let stateTemp = {};
            stateTemp.photos = [];
            stateTemp.photoEnCoursDeChargement = false;
            stateTemp.messagePhotoEnCoursTraitement = '';
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _affichagePhoto(rowGUID) {
        let idOperation = this.props.idOperation;

        if (idOperation > 0 && rowGUID != null) {
            this.setState({ photoEnCoursDeChargement: true, messagePhotoEnCoursTraitement: "Chargement de la photo" });

            let _chargementFicheOperation_PhotoTailleReelle = DataOperation._chargementFicheOperation_PhotoTailleReelle(rowGUID);

            _chargementFicheOperation_PhotoTailleReelle
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.photoSelectionnee = objetData.fileData;
                        stateTemp.photoEnCoursDeChargement = false;
                        stateTemp.messagePhotoEnCoursTraitement = '';
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this.setState({ photoSelectionnee: null });

            let stateTemp = {};
            stateTemp.photoSelectionnee = null;
            stateTemp.photoEnCoursDeChargement = false;
            stateTemp.messagePhotoEnCoursTraitement = '';
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _chargementDocumentsOperation() {
        let idOperation = this.props.idOperation;

        if (idOperation > 0) {
            this.setState({ documentEnCoursDeChargement: true, messageDocumentEnCoursTraitement: "Chargement des documents de l'opération" });

            let chargementFicheOperation_DocumentsOperation = DataOperation._chargementFicheOperation_DocumentsOperation(idOperation);

            chargementFicheOperation_DocumentsOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let listeGroupesDocuments = [];

                        if (objetData.length > 0) {
                            let typeDocumentTrav = objetData[0].typeDocument;
                            let nbTypeDocument = 0;
                            let depart = 0;

                            objetData.forEach(function (value, index) {
                                let typeDocument = value.typeDocument;

                                if (typeDocument === typeDocumentTrav) {
                                    nbTypeDocument++;
                                }
                                else {
                                    listeGroupesDocuments.push({ key: typeDocumentTrav, name: typeDocumentTrav, startIndex: depart, count: nbTypeDocument });

                                    typeDocumentTrav = typeDocument;
                                    depart = (depart + nbTypeDocument);
                                    nbTypeDocument = 1;
                                }

                                // Dernier de la liste
                                if (index === (objetData.length - 1)) {
                                    listeGroupesDocuments.push({ key: typeDocumentTrav, name: typeDocumentTrav, startIndex: depart, count: nbTypeDocument });
                                }
                            });
                        }

                        let stateTemp = {};
                        stateTemp.documentsOperation = objetData;
                        stateTemp.groupesDocumentsOperation = listeGroupesDocuments;
                        stateTemp.documentEnCoursDeChargement = false;
                        stateTemp.messageDocumentEnCoursTraitement = '';
                        stateTemp.affichageOperation = false;
                        stateTemp.affichagePhotos = false;
                        stateTemp.affichageDocuments = true;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            let stateTemp = {};
            stateTemp.documentsOperation = [];
            stateTemp.groupesDocumentsOperation = [];
            stateTemp.documentEnCoursDeChargement = false;
            stateTemp.messageDocumentEnCoursTraitement = '';
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _chargementDocumentsLot() {
        let idOperation = this.props.idOperation;
        let idLot = this.props.idLot;

        if (idOperation > 0 && idLot > 0) {
            this.setState({
                documentEnCoursDeChargement: true,
                messageDocumentEnCoursTraitement: "Chargement des documents du lot"
            });

            let _chargementFicheOperation_DocumentsLot = DataOperation._chargementFicheOperation_DocumentsLot(idOperation, idLot);

            _chargementFicheOperation_DocumentsLot
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let listeGroupesDocuments = [];

                        if (objetData.length > 0) {
                            let typeDocumentTrav = objetData[0].typeDocument;
                            let nbTypeDocument = 0;
                            let depart = 0;

                            objetData.forEach(function (value, index) {
                                let typeDocument = value.typeDocument;

                                if (typeDocument === typeDocumentTrav) {
                                    nbTypeDocument++;

                                    if (index === (objetData.length - 1)) {
                                        // Dernier de la liste
                                        listeGroupesDocuments.push({ key: typeDocumentTrav, name: typeDocumentTrav, startIndex: depart, count: nbTypeDocument });
                                    }
                                }
                                else {
                                    listeGroupesDocuments.push({ key: typeDocumentTrav, name: typeDocumentTrav, startIndex: depart, count: nbTypeDocument });

                                    typeDocumentTrav = typeDocument;
                                    depart = (depart + nbTypeDocument);
                                    nbTypeDocument = 1;
                                }
                            });
                        }

                        let stateTemp = {};
                        stateTemp.documentsLots = objetData;
                        stateTemp.groupesDocumentsLots = listeGroupesDocuments;
                        stateTemp.numLot = (objetData.length > 0 ? objetData[0].numero : null);
                        stateTemp.documentEnCoursDeChargement = false;
                        stateTemp.messageDocumentEnCoursTraitement = '';
                        stateTemp.affichageOperation = false;
                        stateTemp.affichagePhotos = false;
                        stateTemp.affichageDocuments = true;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            let stateTemp = {};
            stateTemp.documentsLots = [];
            stateTemp.groupesDocumentsLots = [];
            stateTemp.numLot = null;
            stateTemp.documentEnCoursDeChargement = false;
            stateTemp.messageDocumentEnCoursTraitement = '';
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _onPivotLinkClick = (item, ev) => {
        if (item.key === ".$operation") {
            this.setState({ affichageOperation: true, affichagePhotos: false, affichageDocuments: false });
        }
        else if (item.key === ".$photos") {
            this._chargementPhotos();
        }
        else if (item.key === ".$documents") {
            this._getUtilisateurConnecte();
            this._chargementDocumentsOperation();
            this._chargementDocumentsLot();
        }
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    _getUtilisateurConnecte() {
        let chargementGetUtilisateurConnecte = Data._chargementGetUtilisateurConnecte();

        chargementGetUtilisateurConnecte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let valeurRetour = responseFetch.reponseAPIobjet;

                    let compte = valeurRetour[0].compteTrav;

                    this.setState({
                        objMail: {
                            destinataire: "",
                            copie: compte.email || "",
                            objet: "",
                            listPiecesJointes: [],
                            corps: `\r\n\r\nCordialement\r\n\r\n${compte.nom} ${compte.prenom}\r\n\r\nEmail : ${compte.email}\r\nTéléphone : ${compte.tel}`
                        }
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.objMail = {
                        destinataire: "",
                        copie: "",
                        objet: "",
                        listPiecesJointes: [],
                        corps: ""
                    };

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
        //this.setState({});
        //this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if (((this.props.idOperation != null && this.props.idOperation !== this.state.idOperation) || (this.props.idLot !== 0 && this.props.idLot !== this.state.idLot)) && !this.state.enCoursDeTraitement) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        return this._creationContent();
    }
}
